export const CAMERA_FAR_RADIUS_SCALE = 1000;
export const BACKGROUND_RADIUS_SCALE = CAMERA_FAR_RADIUS_SCALE / 10;
export const RADIUS = 300;

export const MarkerTypes = {
  BAR: 'bar',
  DOT: 'dot',
};
